import type { TimelineEventType } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event";

export interface TimelineEventGroup {
  id: string;
  label: string;
  types: readonly TimelineEventType[];
}

export const timelineEventGroups: readonly TimelineEventGroup[] = [
  {
    id: "support_ticket_created",
    label: "Support ticket created",
    types: ["support_ticket_created"],
  },
  {
    id: "support_ticket_status_changed",
    label: "Status changed",
    types: ["support_ticket_status_changed"],
  },
  {
    id: "support_ticket_priority_changed",
    label: "Priority changed",
    types: ["support_ticket_priority_changed"],
  },
  {
    id: "support_ticket_assigned",
    label: "Assignment changed",
    types: ["support_ticket_assigned"],
  },
  {
    id: "support_ticket_read",
    label: "Marked as read",
    types: ["support_ticket_read"],
  },
  {
    id: "support_ticket_merge_activity",
    label: "Merge activity",
    types: ["support_ticket_merged", "support_ticket_merge_undone"],
  },
  { id: "topic_handoff", label: "Handoff", types: ["topic_handoff"] },
  {
    id: "message_activity",
    label: "Message activity",
    types: ["message_sent", "message_received"],
  },
  { id: "thread_created", label: "Thread created", types: ["thread_created"] },
  {
    id: "tag_activity",
    label: "Tag activity",
    types: ["tag_added", "tag_removed"],
  },
  { id: "rules_triggered", label: "Rule applied", types: ["rules_triggered"] },
  {
    id: "support_ticket_migrated_from_v1",
    label: "Migrated from v1",
    types: ["support_ticket_migrated_from_v1"],
  },
  {
    id: "legacy_timeline_event",
    label: "Legacy activity",
    types: ["legacy_timeline_event"],
  },
];

export const allGroupIds: readonly string[] = timelineEventGroups.map(
  (g) => g.id,
);

const eventTypeToGroupId = new Map<TimelineEventType, string>(
  timelineEventGroups.flatMap((g) => g.types.map((t) => [t, g.id])),
);

export function getGroupIdForEventType(
  eventType: TimelineEventType,
): string | undefined {
  return eventTypeToGroupId.get(eventType);
}

export function isGroupId(value: string): boolean {
  return allGroupIds.includes(value);
}
